import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';
import { v4 } from 'uuid';

var useNoscroll = function useNoscroll(elem, disableScroll) {
  var _useState = useState(function () {
      return "disabledScroll_".concat(v4());
    }),
    _useState2 = _slicedToArray(_useState, 1),
    className = _useState2[0];
  useEffect(function () {
    var style = document.createElement('style');
    style.innerHTML = "\n\t\t\t.".concat(className, " {\n\t\t\t\toverflow: hidden;\n\t\t\t}\n\t\t");
    document.head.appendChild(style);
    return function () {
      document.head.removeChild(style);
    };
  }, [className]);
  useEffect(function () {
    if (!elem) {
      return;
    }
    if (disableScroll) {
      elem.classList.add(className);
    }
    return function () {
      return elem.classList.remove(className);
    };
  }, [disableScroll, elem, className]);
};

export { useNoscroll };
